import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import { toastr } from 'react-redux-toastr';
import CreateScreensaverComponent from './component';

class CreateScreensaverContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      imageId: 0,
      imagePath: '',
      imageDescription: '',
      imageType: '',
      VmTypeId: '',
      ScreensaverUrl: '',
      VmTypeOption: [],
      imageLoaded: false,
    };
  }
    componentDidMount() {
    const {imageId}= this.props.match.params;
    
    this.setState(prev => ({
      imageId: parseInt(imageId,10),
      loading: true
    }));
    this.props.getDataFromAPI(
      `/screensaver/detail?imageId=${imageId}`,
      'GET',
      undefined,
      response => {
        this.setState(prev => ({
          imagePath: response.name,
          imageDescription: response.image_description,
          imageType: response.image_type,
          VmTypeId: response.vending_machine_type_id,
          ScreensaverUrl: response.screen_saver_url
        }));
        
      },
      err => {
        toastr.error('ERROR', err.message);
        console.log(err);
        this.setState(prev =>({
          loading: false
        }))
      }
    );
    this.setState(prev => ({
      loading: false
    }));

    this.props.getDataFromAPI(
      `/vendingmachines/vmtypes`,
      'GET',
      undefined,
      response => {
        const VmTypeOption = response.list.map(vmType=>({
          value: vmType.id,
          text: vmType.type
        }))
        this.setState(prev =>({
         loading:false,  
         VmTypeOption
        }));
      },
      err => {
        toastr.error('ERROR', 'Unable to fetch VM types');
        console.log(err);
        this.setState(prev =>({
          loading: false
        }))
      }
    );
    
  }

  onChangeOnImagePath = (e,data)=>{
    this.setState(prev => ({
      imagePath: data.value,
      ScreensaverUrl: `${prev.imageType}/${data.value}`,
      imageLoaded: false
    }))
  }

 
  

  onChangeOnImageDescription = (e,data)=>{
    this.setState(prev => ({
      imageDescription: data.value
    }))
  }

  onChangeOnVmTypeId = (e,data)=>{    
    this.setState(prev =>({
      VmTypeId: data.value
    }));
  }

  onChangeOnImageType = (e,data)=>{
    this.setState(prev =>({
      imageType: data.value,
      ScreensaverUrl: `${data.value}/${prev.imagePath}`,
      imageLoaded: false
    }));
  }

  
  
  onClickOnSave = () => {
    const {imageDescription,VmTypeId,imageType,imagePath,imageId,imageLoaded}= this.state;
    if(!imageDescription || !VmTypeId || !imageType || !imagePath){
      toastr.error('ERROR', 'Form fields are empty');
      return;
    }
    if(!imageLoaded){
      toastr.error('ERROR', 'Image Not Found');
      return;
    }
    this.props.getDataFromAPI(
      `/screensaver/update?imageId=${this.state.imageId}`,
      'PATCh',
      {
        imageDescription,
        imagePath,
        imageType,
        id:imageId,
        VmTypeId: parseInt(VmTypeId,10)
      },
      response => {
        toastr.success('Successful', 'Image Is Updated');
      },
      err => {
        toastr.error('ERROR', err.message);
        console.log(err);
      }
    );
    
  }
  onImageLoad = () => {
    this.setState(prev => ({
      imageLoaded: true
    }));
  }


  render() {
    return (
      <CreateScreensaverComponent 
      imageId={this.state.imageId}
      imagePath={this.state.imagePath}
      imageDescription={this.state.imageDescription}
      imageType={this.state.imageType}
      imageLoaded={this.state.imageLoaded}
      VmTypeId={this.state.VmTypeId}
      ScreensaverUrl={this.state.ScreensaverUrl}
      VmTypeOption={this.state.VmTypeOption}
      onChangeOnImagePath={this.onChangeOnImagePath}
      onChangeOnImageId={this.onChangeOnImageId}
      onChangeOnImageDescription={this.onChangeOnImageDescription}
      onChangeOnImageType={this.onChangeOnImageType}
      onChangeOnVmTypeId={this.onChangeOnVmTypeId}
      onClickOnSave={this.onClickOnSave}
      onImageLoad={this.onImageLoad}
      />
    );
  }
}

export default connect(
  null,
  { getDataFromAPI }
)(CreateScreensaverContainer);



// WEBPACK FOOTER //
// ./src/Modules/UpdateImage/container.jsx